import {
  CRAFTSMAN_QUALITY_PROMPT_DEFAULT,
  COST_TO_CURE_ANALYSIS_PROMPT_DEFAULT,
  COMMENTARY_REVIEW_PROMPT_DEFAULT,
  ImageAnalysisSample,
  MLSID,
  UAD_RATINGS_PROMPT_DEFAULT,
  schAddress,
} from '@aloft/toolkit-shared';

export type AnalysisMode = 'commentaryReview' | 'costToCure' | 'craftsmanQuality' | 'uadRatings';

export const GEMINI_MODELS: { id: string; label: string }[] = [
  { id: 'gemini-flash-latest', label: 'Gemini Flash (Latest)' },
  { id: 'gemini-3.5-flash', label: 'Gemini 3.5 Flash (stable, thinking)' },
  { id: 'gemini-3.1-flash-lite', label: 'Gemini 3.1 Flash-Lite (stable, thinking)' },
  { id: 'gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro (preview, thinking)' },
  { id: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro (stable, thinking)' },
  { id: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash (stable, thinking)' },
  { id: 'gemini-2.5-flash-lite', label: 'Gemini 2.5 Flash-Lite (stable, thinking)' },
];

export const DEFAULT_MODEL = 'gemini-flash-latest';

export const DEFAULT_PROMPTS: Record<AnalysisMode, string> = {
  commentaryReview: COMMENTARY_REVIEW_PROMPT_DEFAULT,
  costToCure: COST_TO_CURE_ANALYSIS_PROMPT_DEFAULT,
  craftsmanQuality: CRAFTSMAN_QUALITY_PROMPT_DEFAULT,
  uadRatings: UAD_RATINGS_PROMPT_DEFAULT,
};

export type CommonFields = {
  analysisMode: AnalysisMode;
  model: string;
  promptOverride?: string;
  sample: ImageAnalysisSample;
  compress: boolean;
  submittedLabel: string;
};

type ImageAnalysisCommonFields = Omit<CommonFields, 'analysisMode'> & {
  analysisMode: 'craftsmanQuality' | 'uadRatings';
};

type CostToCureCommonFields = Omit<CommonFields, 'analysisMode'> & {
  analysisMode: 'costToCure';
};

type CommentaryReviewCommonFields = Omit<CommonFields, 'analysisMode' | 'compress' | 'sample'> & {
  analysisMode: 'commentaryReview';
};

export type ImageAnalysisFormSubmit =
  | (ImageAnalysisCommonFields & { lookupType: 'mlsId'; mlsid: MLSID; listingID: string })
  | (ImageAnalysisCommonFields & { lookupType: 'address'; address: ReturnType<typeof schAddress.parse> })
  | (CostToCureCommonFields & { inputMode: 'toolkitOrder'; orderID: string })
  | (CostToCureCommonFields & {
      inputMode: 'manual';
      reportId: string;
      appraisal: {
        costToCureAmount?: number;
        commentary?: string;
        conditionRating?: string;
      };
    })
  | (CommentaryReviewCommonFields & { orderID: string });
